import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import { FormEventHandler, useCallback, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePostManualsAdd } from '../../../api/manual/manual';
import { ErrorInfo } from '../../../api/model';
import { useDefaultOptions } from '../../../hooks/api';
import yup from '../../../utils/custom-yup';
import FileDrop from '../../atoms/FileDrop';
import Modal from '../../modules/Modal';

type Props = {
  onSearch: () => void;
};
function ManualUpload({ onSearch }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);

  const schema = yup.object({
    comment: yup
      .string()
      .nullable()
      .transform((v) => (v ? (v as string) : undefined)),
    importFiles: yup.array().required(),
  });

  const [isModal, setIsModal] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const handleClose = () => {
    setIsModal(false);
    reset();
  };
  const { mutateAsync, isLoading } = usePostManualsAdd<AxiosError<ErrorInfo>, unknown>(options);

  const onSubmit: FormEventHandler<HTMLFormElement> = useCallback(
    (e) => {
      e.preventDefault();
      void handleSubmit(async (data: FieldValues) => {
        if (data.importFiles.length > 0) {
          await mutateAsync(
            { data: { file: data.importFiles?.[0], comment: getValues('comment') } },
            {
              onSuccess: () => {
                onSearch();
                reset();
                setIsModal(false);
              },
            }
          );
        }
      })();
    },
    [handleSubmit, mutateAsync, getValues, onSearch, reset]
  );

  return (
    <>
      <li onClick={() => setIsModal(true)} style={{ cursor: 'pointer' }}>
        <i className="fa-solid fa-upload" />
        {t('アップロード')}
      </li>
      <Modal active={isModal} additionalClassName="mtsp" displayCloseButton onClose={handleClose}>
        <form onSubmit={onSubmit}>
          <fieldset className="fieldset-reset">
            <div className="formarea1">
              <label htmlFor="">{t('ファイル名')}</label>
              <div>
                <FileDrop id="importFiles" name="importFiles" setValue={setValue} />
                {errors.importFiles?.message != null && (
                  <p className="form-error">{errors.importFiles.message.toString()}</p>
                )}
              </div>
            </div>
            <div className="formarea1" style={{ marginTop: '10px' }}>
              <label htmlFor="comment">{t('コメント')}</label>
              <textarea rows={10} cols={33} {...register('comment')} />
            </div>
            <div className="btnfr btnfr2 mb0">
              <div>
                <button type="button" className="text-button" onClick={() => handleClose()}>
                  <span className="btn2 mr10 btnbg-g">
                    <span className="modal-close2">{t('キャンセル')}</span>
                  </span>
                </button>
                <span>
                  <input
                    type="submit"
                    id=""
                    name=""
                    value={t('更新').toString()}
                    className="btn1"
                    disabled={isLoading}
                  />
                </span>{' '}
              </div>
            </div>
          </fieldset>
        </form>
      </Modal>
    </>
  );
}
export { ManualUpload };
